import { Api } from "./Api.class";
const endpoint = "invitations";
const invitationsAPI = new Api(endpoint);
export default invitationsAPI;
